import PropTypes from 'prop-types';
import React from 'react';
import { Drawer } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import NavBar from '../../NavBar/Navbar';
import styles from '../styles';

const useStyles = makeStyles()(() => styles);

/**
 * Contenedor común de las variantes del sidebar: el Drawer, el NavBar superior
 * y el área scrolleable. Las variantes pasan su contenido como children.
 */
function SideBarShell({ isOpen, toggleDrawer, actions, navBarProps, children }) {
  const { classes } = useStyles();

  return (
    <Drawer
      anchor="left"
      classes={classes}
      open={isOpen}
      onClose={toggleDrawer}
      PaperProps={{
        sx: {
          width: 300,
          backgroundColor: 'background.paper',
          // Un único contenedor con scroll propio, anclado al viewport.
          height: '100%',
          overflowY: 'auto',
          overflowX: 'hidden',
        },
      }}>
      <NavBar {...navBarProps} sideBar actions={actions} />
      {children}
    </Drawer>
  );
}

SideBarShell.propTypes = {
  isOpen: PropTypes.bool,
  toggleDrawer: PropTypes.func,
  actions: PropTypes.object,
  navBarProps: PropTypes.object,
  children: PropTypes.node,
};

export default SideBarShell;
